export function deepCopy(obj: any): any {
  if (obj === undefined) {
    return undefined;
  }
  const objIsArray = Array.isArray && Array.isArray(obj);
  const result: any[] | any = objIsArray ? [] : {};

  if (objIsArray) {
    for (const child of obj) {
      result.push(deepCopy(child));
    }
  } else if (obj && typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      if (obj && typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key]);
      } else {
        result[key] = obj[key];
      }
    });
  } else {
    return obj;
  }

  return result;
}

export function deepMerge(obj: any, src: any): any {
  if (obj === undefined) {
    return undefined;
  }
  const objIsArray = Array.isArray && Array.isArray(obj);
  const srcIsArray = Array.isArray && Array.isArray(src);
  if (objIsArray) {
    if (srcIsArray) {
      (obj as any[]).find((item, index) => {
        obj[index] = deepMerge(obj[index], src[index]);
      });
    }
    return (obj as any[]).filter(Boolean);    // filter undefined items
  } else if (obj && typeof obj === 'object') {
    if (src && typeof src === 'object') {
      Object.keys(obj).forEach((key) => {
        if (obj && typeof obj[key] === 'object') {
          obj[key] = deepMerge(obj[key], src[key]);
        } else {
          obj[key] = src[key];
        }
      });
    } else {
      return src;
    }
  }

  return obj;
}
